import ExchangeList from '@/components/Exchange/ExchangeList'

let ExchangeRouter = [
  {
    path: '/exchange',
    name: 'ExchangeList',
    component: ExchangeList,
    meta: {
      title: 'Échanges',
      requiresAuth: true,
      authorizations: ['exchange_index', 'desktop_access']
    }
  },
]

export default ExchangeRouter



// WEBPACK FOOTER //
// ./src/components/Exchange/router.js